import { useState } from "react";
import { adminLoginApi } from "api/admin";
import { C, FONT, SESSION_KEY, Field, inputStyle } from "./admin_ui";

export default function AdminLogin({ onSuccess }) {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e?.preventDefault?.();
    setError("");
    if (!id.trim() || !password) {
      setError("아이디와 비밀번호를 입력해주세요.");
      return;
    }
    setLoading(true);
    const r = await adminLoginApi({ id: id.trim(), password });
    setLoading(false);
    if (r?.success) {
      try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify({ id: r.id || id }));
      } catch {}
      onSuccess?.(r.id || id);
    } else {
      setError(r?.error || "로그인에 실패했습니다.");
    }
  };

  return (
    <div
      style={{
        fontFamily: FONT,
        background: C.bg,
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: "100%",
          maxWidth: 400,
          background: "#fff",
          border: `1px solid ${C.line}`,
          borderRadius: 18,
          padding: "32px 28px 28px",
          boxShadow: "0 12px 40px rgba(0,0,0,0.06)",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 6,
          }}
        >
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: `linear-gradient(135deg, ${C.greenDark}, #064E3B)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontWeight: 800,
              fontSize: 18,
            }}
          >
            🛠
          </div>
          <div>
            <div
              style={{
                fontSize: 20,
                fontWeight: 800,
                color: C.ink,
                letterSpacing: "-0.02em",
              }}
            >
              뚝딱이 관리자
            </div>
            <div style={{ fontSize: 12, color: C.sub }}>운영자 전용 콘솔</div>
          </div>
        </div>

        <Field label="아이디">
          <input
            value={id}
            onChange={(e) => setId(e.target.value)}
            placeholder="아이디를 입력하세요"
            disabled={loading}
            autoFocus
            style={inputStyle}
          />
        </Field>
        <Field label="비밀번호">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="비밀번호를 입력하세요"
            disabled={loading}
            style={inputStyle}
          />
        </Field>

        {error && (
          <div
            style={{
              padding: "10px 12px",
              borderRadius: 10,
              background: "#FEF2F2",
              border: "1px solid #FECACA",
              color: "#991B1B",
              fontSize: 13,
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            marginTop: 6,
            height: 48,
            borderRadius: 10,
            border: "none",
            background: loading ? "#9CA3AF" : C.greenDark,
            color: "#fff",
            fontSize: 15,
            fontWeight: 700,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "로그인 중..." : "로그인"}
        </button>

        <div
          style={{
            fontSize: 11,
            color: C.sub,
            textAlign: "center",
            marginTop: 4,
          }}
        >
          관리자 계정으로 로그인하세요.
        </div>
      </form>
    </div>
  );
}
